import { $authHost } from "../../http";
import { 
    REFERRAL_FORM_GET_REQUEST, REFERRAL_FORM_GET_SUCCESS, REFERRAL_FORM_GET_ERROR, 
    REFERRAL_FORM_GET_BY_KEY_REQUEST, REFERRAL_FORM_GET_BY_KEY_SUCCESS, REFERRAL_FORM_GET_BY_KEY_ERROR, 
    REFERRAL_FORM_ADD_REQUEST, REFERRAL_FORM_ADD_SUCCESS, REFERRAL_FORM_ADD_ERROR, 
    REFERRAL_FORM_EDIT_REQUEST, REFERRAL_FORM_EDIT_SUCCESS, REFERRAL_FORM_EDIT_ERROR, 
    REFERRAL_FORM_DELETE_REQUEST, REFERRAL_FORM_DELETE_SUCCESS, REFERRAL_FORM_DELETE_ERROR
} from "../constants/referralFormConstants";

export const getReferralForms = (args) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_FORM_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/referralForm/query",
            args || {},
            config,
        );
        dispatch({
            type: REFERRAL_FORM_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REFERRAL_FORM_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getReferralFormByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_FORM_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/referralForm/${id}`,
        );
        dispatch({
            type: REFERRAL_FORM_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REFERRAL_FORM_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addReferralForm = ({ number, createdAt, schema, filialId, departmentId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_FORM_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/referralForm",
            { number, createdAt, schema, filialId, departmentId },
            config,
        );
        dispatch(getReferralForms(queryArgs || {}));
        dispatch({
            type: REFERRAL_FORM_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_FORM_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editReferralForm = ({ id, number, createdAt, schema, filialId, departmentId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_FORM_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/referralForm",
            { id, number, createdAt, schema, filialId, departmentId },
            config,
        );
        dispatch(getReferralForms(queryArgs || {}));
        dispatch({
            type: REFERRAL_FORM_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_FORM_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteReferralForm = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_FORM_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/referralForm",
            { data: { id } },
            config,
        );
        dispatch(getReferralForms(queryArgs || {}));
        dispatch({
            type: REFERRAL_FORM_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_FORM_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

